import { useState, useEffect } from 'react';
import { adminAPI } from '@/services/api';

const StaffSubjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Subjects and classes will be fetched from API when endpoint is available
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-6 max-w-5xl mx-auto">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-black text-slate-800">My Subjects & Classes</h2>
      </div>

      {/* Assigned Classes */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6">
        <h3 className="font-bold text-slate-800 mb-4 flex items-center gap-2">
          <i className="fas fa-chalkboard text-emerald-500" /> Assigned Classes
        </h3>
        {classes.length > 0 ? (
          <div className="flex flex-wrap gap-3">
            {classes.map((cls, idx) => (
              <span key={idx} className="px-4 py-2 bg-emerald-50 text-emerald-700 rounded-xl text-sm font-semibold">
                {cls}
              </span>
            ))}
          </div>
        ) : (
          <p className="text-sm text-slate-400">No classes assigned yet.</p>
        )}
      </div>

      {/* Assigned Subjects */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
        <div className="p-6 border-b border-slate-100">
          <h3 className="font-bold text-slate-800 flex items-center gap-2">
            <i className="fas fa-book text-emerald-500" /> Assigned Subjects
          </h3>
        </div>
        {subjects.length > 0 ? (
          <div className="divide-y divide-slate-100">
            {subjects.map((subject, idx) => (
              <div key={idx} className="p-5 flex items-center justify-between hover:bg-slate-50 transition-colors">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600">
                    <i className="fas fa-book" />
                  </div>
                  <div>
                    <p className="font-bold text-slate-800">{subject.name}</p>
                    <p className="text-xs text-slate-500">Code: {subject.code}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-sm font-semibold text-slate-600">{subject.classes?.join(', ')}</p>
                  <p className="text-xs text-slate-400">{subject.studentsCount} students</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="p-12 text-center">
            <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="fas fa-book text-2xl text-slate-300" />
            </div>
            <h3 className="font-bold text-slate-600 mb-1">No Subjects Assigned</h3>
            <p className="text-sm text-slate-400">Your assigned subjects will appear here.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StaffSubjects;

